import * as styles from "../styles.css";
import { Typography, Tags, HeaderVariants } from "../../../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import { ms2Hmmss } from "@discovery/roadie";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
export const Duration = ({ durationM }) => (React.createElement(RenderMaybe, null, M.map((duration) => (React.createElement(Typography, { classNameM: M.of(styles.duration), variant: HeaderVariants.subHeadThree, tag: Tags.span },
    React.createElement(React.Fragment, null, ms2Hmmss(duration)))), durationM)));

